// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"7f11a59c","341":"7f11a59c","576":"7f11a59c","831":"7f11a59c","921":"7f11a59c"}[chunkId] + ".chunk.css";
};